import { ActionTypes } from '../constants/index';

export const fetchLiveStreaming = (payload: any) => ({
  type: ActionTypes.LIVE_STREAMING_LIST_REQUEST,
  payload,
});
